import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import TitleCard from '../../../components/TitleCard/TitleCard';
import ConfirmModal from '../../../components/ConfirmModal/ConfirmModal';
import GradientButton from '../../../components/GradientButton/GradientButton';
import CancelButton from '../../../components/CancelButton/CancelButton';

const UsersCreate = ({ onSubmit }) => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: '',
    username: '',
    password: '',
    email: '',
    age: '',
  });

  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmData, setConfirmData] = useState({
    title: '',
    message: '',
    type: 'info', // success | error | warning
  });

  // ✅ Estado para controlar el botón
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true); // 🔒 Deshabilitamos el botón al enviar

    try {
      const token = localStorage.getItem('access_token');
      await axios.post(
        `${process.env.REACT_APP_API_URL}/users/create`,
        formData,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setConfirmData({
        title: 'Usuario creado',
        message: `El usuario "${formData.username}" fue creado exitosamente.`,
        type: 'success',
      });
      setShowConfirm(true);

    } catch (err) {
      console.error('Error creando usuario:', err);
      setConfirmData({
        title: 'Error',
        message: err.response?.data?.message || 'No se pudo crear el usuario. Intenta nuevamente.',
        type: 'error',
      });
      setShowConfirm(true);
    }
  };

  const handleConfirm = () => {
    setShowConfirm(false);
    setIsSubmitting(false); // 🔓 Reactivamos el botón al cerrar el modal

    if (confirmData.type === 'success') {
      navigate('../users-list');
    }
  };

  return (
    <>
      <TitleCard title="Crear Usuario" />

      <form
        onSubmit={handleSubmit}
        className="bg-white px-6 py-6 mt-4 rounded-lg shadow-md flex flex-col gap-4 w-full"
      >
        {/* Grid de 2 columnas */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="flex flex-col">
            <label htmlFor="name" className="text-gray-600 mb-1">Nombre</label>
            <input
              type="text"
              name="name"
              id="name"
              value={formData.name}
              onChange={handleChange}
              className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
              required
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="username" className="text-gray-600 mb-1">Usuario</label>
            <input
              type="text"
              name="username"
              id="username"
              value={formData.username}
              onChange={handleChange}
              className="autofill-white border border-gray-300 rounded bg-white px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
              required
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="password" className="text-gray-600 mb-1">Contraseña</label>
            <input
              type="password"
              name="password"
              id="password"
              value={formData.password}
              onChange={handleChange}
              className="autofill-white border border-gray-300 rounded bg-white px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
              required
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="email" className="text-gray-600 mb-1">Correo Electrónico</label>
            <input
              type="email"
              name="email"
              id="email"
              value={formData.email}
              onChange={handleChange}
              className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
              required
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="age" className="text-gray-600 mb-1">Edad</label>
            <input
              type="number"
              name="age"
              id="age"
              value={formData.age}
              onChange={handleChange}
              className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
              required
              min="0"
              max="99"
            />
          </div>

          <div className="flex self-end gap-2">
            <GradientButton type="submit" disabled={isSubmitting}>
              {isSubmitting ? 'Creando...' : 'Aceptar'}
            </GradientButton>
            <CancelButton onClick={() => navigate(-1)} />
          </div>
        </div>
      </form>

      {/* Modal de confirmación */}
      <ConfirmModal
        isOpen={showConfirm}
        title={confirmData.title}
        message={confirmData.message}
        type={confirmData.type}
        onConfirm={handleConfirm}
        onClose={() => {
          setShowConfirm(false);
          setIsSubmitting(false); // 🔓 También reactivamos si se cierra sin confirmar
        }}
      />
    </>
  );
};

export default UsersCreate;
